module.exports = __webpack_public_path__ + "img/2.b96adbd2.png";